module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0019.jpg?v=f2a9143b";